export default __webpack_public_path__ + "static/media/google-play.0fd81e41.svg";